import { cn } from "@/lib/utils";

export function ArrowIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-3.5 w-2 text-ruby-red", className)}
      fill="none"
      viewBox="0 0 8 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 1L1 7l6 6"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}
